import React, { Component } from 'react';
import differenceWith from 'lodash/differenceWith';
import intersectWith from 'lodash/intersectionWith';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { ActionStepItem } from './ActionStepItem';
import CheckBox from '../../CommonComponents/CheckBox';
import Icon from '../../CommonComponents/Icon';
import { LinkButton } from '../../CommonComponents/Button';
import { StyledTooltip } from './ActionStepsStyles';
import { PulseCheckCategoryIcon } from './PulseCheckCategoryIcon';
import { Box } from '../../CommonComponents/OPL/Box/Box';

class ActionStepsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      idsBeingEdited: [],
    };
    this.order = {};

    this.addItem = this.addItem.bind(this);
    this.removeItem = this.removeItem.bind(this);
    this.updateItem = this.updateItem.bind(this);
    this.transform = this.transform.bind(this);
    this.onActionStepsUlRef = this.onActionStepsUlRef.bind(this);
  }

  UNSAFE_componentWillMount() {
    const p = this.props;
    p.items.forEach(this.addItem);
    this.transform(p);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const p = this.props;
    const np = nextProps;

    if (np.items !== p.items) {
      const added = differenceWith(np.items, p.items, (arrVal, othVal) => arrVal.Id === othVal.Id);
      const removed = differenceWith(
        p.items,
        np.items,
        (arrVal, othVal) => arrVal.Id === othVal.Id,
      );
      const updated = intersectWith(np.items, p.items, (arrVal, othVal) => arrVal.Id === othVal.Id);
      updated.forEach(this.updateItem);
      removed.forEach(this.removeItem);
      added.forEach(this.addItem);
    }

    this.transform(np);
  }

  onActionStepsUlRef(actionStepsUl) {
    const p = this.props;
    if (p.onActionStepsUlRef) {
      if (!this.uuid) {
        this.uuid = uuidv4();
      }
      p.onActionStepsUlRef(actionStepsUl, this.uuid);
    }
  }

  addItem(item) {
    Object.keys(this.order).forEach(key => {
      this.order[key].index += 1;
    });
    this.order[item.Id] = {
      data: item,
      index: 0,
    };
  }

  updateItem(item) {
    this.order[item.Id].data = item;
  }

  removeItem(item) {
    const { index } = this.order[item.Id];
    delete this.order[item.Id];
    Object.keys(this.order).forEach(key => {
      if (this.order[key].index > index) {
        this.order[key].index -= 1;
      }
    });
  }

  transform(p) {
    const items = p.items.map(() => 0);
    Object.keys(this.order).forEach(key => {
      items[this.order[key].index] = this.order[key].data;
    });
    this.setState({
      items,
    });
  }

  render() {
    const p = this.props;
    const s = this.state;

    const getAssigneeName = (type, id) => {
      switch (type) {
        case 0:
          return `${p.currentClient.FirstName} ${p.currentClient.LastName}`;
        case 1:
          return `${p.currentClient.PartnerName}`;
        case 2: {
          const adviser = (p.advisersInTheSameOrg || []).find(({ AdviserId }) => AdviserId === id);

          return adviser && `${adviser.FirstName} ${adviser.LastName}`;
        }
        default:
          return '';
      }
    };

    return (
      <ul className="action-steps-ul" ref={this.onActionStepsUlRef}>
        <li className="action-steps-li-header">
          <div className="action-steps-li-header-left">
            <div className="action-steps-li-header-title">
              {p.title}
              {p.isConsumerArea && (
                <StyledTooltip
                  tag="i"
                  className="fa fa-question-circle"
                  tooltipchildren={p.tooltip}
                  orientation="right"
                />
              )}
            </div>
            {p.showActionNeeded && (
              <button className="action-steps-li-header-add" onClick={p.onAdd}>
                <i className="fa fa-plus action-steps-li-header-add-fa" />
                {p.buttonText}
              </button>
            )}
            {!p.hideReset && (
              <button className="action-steps-li-header-reset" onClick={p.onReset}>
                <i className="fa fa-sync-alt action-steps-li-header-reset-fa" />
                Reset
              </button>
            )}
          </div>
          <div className="action-steps-li-header-right">
            {p.showActionNeeded ? (
              p.actionNeeded && <div className="action-steps-track-indicator" />
            ) : (
              <button className="action-steps-li-header-add" onClick={p.onAdd}>
                <i className="fa fa-plus action-steps-li-header-add-fa" />
                {p.buttonText}
              </button>
            )}
          </div>
        </li>
        <li
          className="add-action-steps"
          style={{
            display: p.isAdding ? 'block' : 'none',
          }}
        >
          <ActionStepItem
            pulseCheckCategory={p.pulseCheckCategory}
            onCancel={p.onCancelAdding}
            onDone={actionStep => p.onDoneAdding(actionStep, s.items)()}
            item={{ Id: null, Text: p.addText, Icon: p.addIcon }}
            advisersInTheSameOrg={p.advisersInTheSameOrg}
            isLoadingAdvisersInTheSameOrg={p.isLoadingAdvisersInTheSameOrg}
            isAssignable={p.isAssignable}
            placeholder={`Type ${p.buttonText} here...`}
            isAdviserArea={p.isAdviserArea}
          />
        </li>
        {s.items.length <= 0 && !p.isAdding && (
          <li className="action-steps-li-empty">{p.emptyStateText}</li>
        )}
        {s.items
          .sort((a, b) => {
            if (a.DueDate === b.DueDate) {
              return new Date(a.CreatedOn).getTime() - new Date(b.CreatedOn).getTime();
            }

            return new Date(a.DueDate ?? 0).getTime() - new Date(b.DueDate ?? 0).getTime();
          })
          .map(item =>
            this.state.idsBeingEdited.includes(item.Id) ? (
              <li className="add-action-steps" key={item.Id}>
                <ActionStepItem
                  pulseCheckCategory={p.pulseCheckCategory}
                  onCancel={() =>
                    this.setState({
                      idsBeingEdited: this.state.idsBeingEdited.filter(id => id !== item.Id),
                    })
                  }
                  onDone={actionStep => {
                    p.onDoneEditing(actionStep)();

                    this.setState({
                      idsBeingEdited: this.state.idsBeingEdited.filter(id => id !== item.Id),
                    });
                  }}
                  item={item}
                  advisersInTheSameOrg={p.advisersInTheSameOrg}
                  isLoadingAdvisersInTheSameOrg={p.isLoadingAdvisersInTheSameOrg}
                  isAssignable={p.isAssignable}
                  isAdviserArea={p.isAdviserArea}
                />
              </li>
            ) : (
              <li
                key={item.Id}
                className="action-steps-li"
                style={{
                  display: item.IsHidden ? 'none' : 'flex',
                }}
              >
                {typeof p.pulseCheckCategory === 'number' ? (
                  <Box position="absolute" style={{ left: 0, margin: '-12px 0 0', top: '50%' }}>
                    <PulseCheckCategoryIcon category={p.pulseCheckCategory} />
                  </Box>
                ) : (
                  <i
                    className="action-steps-icon"
                    data-type={item.Icon}
                    role="img"
                    aria-label={item.Text}
                    title={item.Text}
                  />
                )}

                <div
                  className={item.IsComplete ? 'action-steps-text is-done' : 'action-steps-text'}
                >
                  {item.Text || '\u00a0'}

                  {!item.IsComplete && (
                    <>
                      {p.isAdviserArea && p.isAssignable && (
                        <LinkButton
                          className="edit-button"
                          onClick={() =>
                            this.setState({
                              idsBeingEdited: [...this.state.idsBeingEdited, item.Id],
                            })
                          }
                        >
                          <Icon className="far fa-edit" />
                        </LinkButton>
                      )}

                      {item.AssigneeType !== null && (
                        <div>
                          Assigned Person:{' '}
                          <b>{getAssigneeName(item.AssigneeType, item.AssigneeId)}</b>
                        </div>
                      )}

                      {item.DueDate && (
                        <div>
                          Due Date: <b>{moment(item.DueDate).format('MM/DD/YYYY')}</b>
                        </div>
                      )}
                    </>
                  )}
                </div>
                <div className="action-steps-buttons">
                  {item.IsTask && (
                    <CheckBox
                      controlled
                      checked={item.IsComplete}
                      onChange={p.onChangeStatus({
                        Completion: !item.IsComplete,
                        Text: item.Text,
                        ActionStepKey: item.ActionStepKey,
                      })}
                    />
                  )}

                  <LinkButton onClick={p.onDeleteItem(item.ActionStepKey)}>
                    <Icon className="far fa-trash-alt" />
                  </LinkButton>
                </div>
              </li>
            ),
          )}
      </ul>
    );
  }
}

export default ActionStepsList;
